<template>
    <LoginButtonGroup class="select-profile">
        <LoginButton v-for="(profile, index) in profiles" :key="profile.pk" @click="selectProfile(profile)">
            <UserInitials :index-color="index" />
            <p>
                <span>Roll</span>
                <span>{{ profile.roll_display.displayName }}</span>
            </p>
            <p>
                <span>Yrke</span>
                <span>{{ profile.yrkeskategori_display.displayName }}</span>
            </p>
            <p>
                <span>Vårdenhet</span>
                <span>{{ profile.orgUnit.name }}</span>
            </p>
        </LoginButton>
    </LoginButtonGroup>
</template>

<script setup>
    import { computed } from "vue";
    import { useStore } from "@/store";
    import LoginButtonGroup from "@/components/Auth/LoginButtonGroup.vue";
    import LoginButton from "@/components/Auth/LoginButton.vue";
    import UserInitials from "@/components/UserInitials.vue";

    const store = useStore();

    const emit = defineEmits(["select"]);

    const profiles = computed(() => store.getters["userData/activeProfiles"]);

    const selectProfile = (profile) => {
        emit("select", profile);
    };
</script>

<style lang="scss" scoped>
    .select-profile {
        display: grid;
        grid-template-columns: repeat(4, max-content);
        grid-column-gap: 1rem;
        grid-row-gap: 1rem;

        button {
            display: grid;
            grid-template-columns: subgrid;
            grid-column: 1 / -1;

            p {
                display: grid;

                span:first-child {
                    font-weight: bold;
                    font-size: 0.9rem;
                }
            }
        }
    }
</style>
